/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketFiltersResponse {
    getFixupPrototypeFunction() { return FreshserviceTicketFiltersResponse.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketFiltersResponse>): FreshserviceTicketFiltersResponse {
        let obj = Object.assign(new FreshserviceTicketFiltersResponse(), model);
        FreshserviceTicketFiltersResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketFiltersResponse>): FreshserviceTicketFiltersResponse {
        if (!model) return null;
        return FreshserviceTicketFiltersResponse.newInstance(<FreshserviceTicketFiltersResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketFiltersResponse) {
        if (!obj) return;

        models.FreshserviceTicketFiltersResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketFiltersResponse): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketFiltersResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.status) {
            for (let val of this.status) {
                models.FreshserviceTicketFilterElement.fixupPrototype(val);
            }
        }
        if (this.priority) {
            for (let val of this.priority) {
                models.FreshserviceTicketFilterElement.fixupPrototype(val);
            }
        }
        if (this.department) {
            for (let val of this.department) {
                models.FreshserviceTicketFilterElement.fixupPrototype(val);
            }
        }
    }

    /**
     * Status List
     */
    status: Array<models.FreshserviceTicketFilterElement>;

    /**
     * Priority List
     */
    priority: Array<models.FreshserviceTicketFilterElement>;

    /**
     * Department List
     */
    department: Array<models.FreshserviceTicketFilterElement>;

}
